export default __webpack_public_path__ + "static/media/icon-edit.19377561.svg";